import {
  AppInstallOption,
  IntentInstallOptions,
  PluginsEditorType,
} from '@wix/editor-platform-host-integration-apis';
import { noop } from 'lodash';
import { getOrigin } from '../helpers';
import { IntentInstallStore } from '../IntentInstallStore';
import { IExperimentsApiAdapter } from '../../../utils/experimentsApiAdapter';

export function getCommonAppOptions(
  intentInstallStore: IntentInstallStore,
  appDefIds: string[],
  options: IntentInstallOptions,
  experimentsAPI: IExperimentsApiAdapter,
): Record<string, Partial<AppInstallOption>> {
  const { appsOptions } = options;
  const origin = getOrigin(options);
  const intentApp = intentInstallStore.getIntentApp();

  return appDefIds.reduce((acc, appDefId) => {
    const appVersionIfIntent =
      appDefId === intentApp?.appDefId ? intentApp.version : undefined;

    const appOptions = appsOptions?.[appDefId];
    acc[appDefId] = {
      origin,
      isSilent: options.isSilent ?? false,
      appVersion: appOptions?.appVersion || appVersionIfIntent,
      ...(appOptions || {}),
    };
    if (
      experimentsAPI.enabled('se_autoPopulatePluginPartOfInstallation') ||
      experimentsAPI.enabled(
        'specs.responsive-editor.autoPopulatePluginPartOfInstallation',
      )
    ) {
      acc[appDefId].pluginsAutoPopulate = {
        isSilent: options.isSilent ?? false,
      };
    }
    return acc;
  }, {} as Record<string, Partial<AppInstallOption>>);
}

export const createPromiseWithResolvers = <T>() => {
  let resolve: (arg: T) => void = noop;
  let reject: (reason?: unknown) => void = noop;

  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return { promise, resolve, reject };
};
